import { FormControl, MenuItem, Select, SelectProps } from '@mui/material';
import React from 'react';

import { MccMatchEnum } from 'app/enum/mcc-match-enum';

type MccMatchTypeProps = SelectProps<MccMatchEnum> & {
    value: MccMatchEnum;
    name: string;
    size?: 'medium' | 'small';
};

export const MccMatchType: React.FunctionComponent<MccMatchTypeProps> = (props) => {
    const { ...rest } = props;

    return (
        <FormControl style={{ minWidth: '5em' }} size={props.size}>
            <Select {...rest}>
                <MenuItem value={MccMatchEnum.IN}>IN</MenuItem>
                <MenuItem value={MccMatchEnum.NOT_IN}>NOT IN</MenuItem>
            </Select>
        </FormControl>
    );
};
